import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bar", "segment"]
  static values = {
    totalFrames: Number,
    fps: Number,
    updateUrl: String
  }

  connect() {
    this.dragging = null
    this.dragStartX = 0
    this.dragOriginalLeft = 0

    this.boundDragMove = this.dragMove.bind(this)
    this.boundDragEnd = this.dragEnd.bind(this)
  }

  dragStart(event) {
    event.preventDefault()
    const segment = event.currentTarget

    this.dragging = segment
    this.dragStartX = event.clientX
    this.dragOriginalLeft = parseFloat(segment.style.left) || 0

    segment.classList.add("opacity-75", "ring-2", "ring-indigo-300")

    document.addEventListener("mousemove", this.boundDragMove)
    document.addEventListener("mouseup", this.boundDragEnd)
  }

  dragMove(event) {
    if (!this.dragging) return

    const bar = this.barTarget
    const barRect = bar.getBoundingClientRect()
    const deltaX = event.clientX - this.dragStartX
    const deltaPct = (deltaX / barRect.width) * 100

    let newLeft = this.dragOriginalLeft + deltaPct
    newLeft = Math.max(0, Math.min(100, newLeft))

    this.dragging.style.left = `${newLeft}%`
  }

  dragEnd(event) {
    if (!this.dragging) return

    const segment = this.dragging
    const segmentId = segment.dataset.segmentId
    const newLeftPct = parseFloat(segment.style.left) || 0
    const newStartFrame = Math.round((newLeftPct / 100) * this.totalFramesValue)

    segment.classList.remove("opacity-75", "ring-2", "ring-indigo-300")

    this.dragging = null
    document.removeEventListener("mousemove", this.boundDragMove)
    document.removeEventListener("mouseup", this.boundDragEnd)

    // Send update to server
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.updateUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: `segment_id=${segmentId}&start_frame=${newStartFrame}`
    }).then(response => {
      if (!response.ok) {
        segment.style.left = `${this.dragOriginalLeft}%`
      }
    }).catch(() => {
      segment.style.left = `${this.dragOriginalLeft}%`
    })
  }

  disconnect() {
    document.removeEventListener("mousemove", this.boundDragMove)
    document.removeEventListener("mouseup", this.boundDragEnd)
  }
}
